/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const FireFlameCurvedSolidV6 = (props) => (
  <Icon {...props} name="Fire Flame Curved Solid V6">
    <path d="M14 9.972C14 13.31 11.309 16 8 16s-6-2.692-6-6c0-1.833.869-3.338 1.705-4.191A.737.737 0 0 1 5 6.296v2.672c0 1.099.874 2.016 1.974 2.029A1.997 1.997 0 0 0 9 8.999C9 6.249 3.528 5.995 7.37.337 7.792-.279 8.75 0 8.75.744 8.722 3.968 14 4.677 14 9.971z" />
  </Icon>
);

export default FireFlameCurvedSolidV6;
